
<template>
	<el-form
		ref="formInline"
		name="query__form"
		inline
        label-position="right" label-width="80px"
		@keydown.native.enter.prevent="confirmSearch">

		<el-form-item

            label="关键字"


			prop="keyword">
			<el-input
				v-model="formValidate.keyword"
				placeholder="请输入关键字"
				name="query__keyword"
                size="medium"
				type="text"/>
		</el-form-item>

		<el-form-item>
			<el-button
				type="primary"
                size="medium"
				name="query__submit"
				@click="confirmSearch">
				搜索
			</el-button>
		</el-form-item>

	</el-form>



</template>
<script>

export default {

	name: 'MterialSearchForm',

	data() {
		return {

			formValidate: {

				keyword: '', // 关键字

			}, // 搜索框的对象参数
		};
	},

	methods: {
		/**
         * 确认搜索
         * @return {undefined}
         */
		confirmSearch() {
			const param = {
				keyword: this.formValidate.keyword,
			};

			this.$emit('search', param);
		},

	},

};

</script>
